module.exports = __webpack_public_path__ + "static/media/free52weeksOfContent.46ea32d1.md";